import {
  GenericSettingsValue,
  genericValueFromResponse,
  genericValueToUpsertRequest,
} from './GenericSettingsValue';

export interface Settings {
  type: string;
  key: string;
  createdAt: Date;
  updatedAt: Date;

  genericValue?: GenericSettingsValue;
}

export const settingsFromResponse = (responseData: any): Settings => ({
  type: responseData.type,
  key: responseData.key,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),

  genericValue: responseData.generic_value
    ? genericValueFromResponse(responseData.generic_value)
    : undefined,
});

export const settingsToUpsertRequest = (settings: Settings) => ({
  type: settings.type,
  key: settings.key,

  generic_value: settings.genericValue
    ? genericValueToUpsertRequest(settings.genericValue)
    : undefined,
});
